import React from 'react';
import { observer } from 'mobx-react-lite';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditTime } from './edit/EditTime';
import { ViewTime } from './view/ViewTime';
export var Time = observer(function (_ref) {
  var id = _ref.id,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    return /*#__PURE__*/React.createElement(EditTime, {
      id: id,
      value: toTextQuestionAnswer(questionStore.currentAnswer),
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      onChange: function onChange(value) {
        var returnValue = value;
        if (value.includes('am') || value.includes('pm')) {
          returnValue = value.slice(0, -2);
        }
        questionStore.setAnswer(returnValue);
      },
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewTime, {
    id: id,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode
  });
});